<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15urcs/tc-custom/9781955682220.jpg?1731411132789" alt="This image is the cover for the book Cristo, el Hijo eterno"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cristo, el Hijo eterno
      </h1>
      <p class="bookDescription body article font2">
        <p>Un hermoso retrato de la Deidad en el Evangelio de Juan. En Cristo, el Hijo eterno, A. W. Tozer sumerge al lector en un reflexivo y pastoral análisis del Evangelio de Juan, evangelio que ha desconcertado —por siglos— a los eruditos bíblicos. Lejos de la simplicidad de los evangelios sinópticos, la interpretación que el apóstol Juan brinda es mucho más enigmática, aunque espiritual. El autor examina este evangelio en porciones considerando, desde una perspectiva cualitativa, la relación de Dios con el hombre. Tozer da vida a su poderosa teología en este libro, recordándole al lector la extraordinaria gracia de Dios y pronunciando dichos memorables y motivadores como su conocido lema “¡Todo está mal hasta que Jesús lo arregla!” La narrativa completa del evangelio se extiende a lo largo de este libro, cada página trae un nuevo principio del plan maestro de redención implementado por Dios, dejando al lector inspirado para hacer —en obediencia— la voluntad de su Creador.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        A. W. Tozer
      </h2>
      
      <p class="authorDescription body article">A. W. TOZER fue un teólogo autodidacta que recibió dos doctorados honorarios y pastoreó varias iglesias, incluyendo la iglesia Southside Alliance en Chicago por 31 años. Es el autor del clásico espiritual La búsqueda de Dios por el hombre, Tragedia en la iglesia, Jesus, nuestro hombre en gloria, La guerra del Espíritu, Mi búsqueda diaria, Los atributos de Dios vol. 1 y 2, entre otros.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?74585be3